import { LANGUAGE_CHANGE } from '../../../actions/types'

/**
 * Rileva la lingua del browser.
 * Cerca prima la lingua memorizzata nel local storage,
 * poi la lingua del browser.
 * Se non viene rilevata alcuna lingua, restituisce 'it' come default.
 *
 * @returns {string} La lingua rilevata.
 */
const detectLanguage = () => {
  if (localStorage.getItem('language')) {
    return localStorage.getItem('language') || 'it'
  }
  if (/^en\b/.test(navigator.language)) return 'en'
  return 'it'
}

const INITIAL_STATE = {
  language: detectLanguage()
}

/**
 * Reducer per la gestione della lingua dell'applicazione.
 *
 * Utilizza l'azione LANGUAGE_CHANGE per cambiare la lingua.
 * Se non è rilevata alcuna azione, restituisce lo stato iniziale.
 *
 * @param {object} state Stato corrente.
 * @param {object} action Azione da gestire.
 * @returns {object} Nuovo stato.
 */
export const languageReducer = (state = INITIAL_STATE, action) => {
  if (action.type === LANGUAGE_CHANGE) {
    return { language: action.language }
  }
  return state
}
